var _defs, _path, _rect, _path2, _path3, _path4, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArticle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #47464b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.6,91.09H9.4c-.55,0-.99-.45-.99-.99V9.91c0-.55.45-.99.99-.99h131.21c.55,0,.99.45.99.99v80.19c0,.55-.45.99-.99.99ZM10.22,89.28h129.57V10.73H10.22v78.55Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.31,
    y: 19.23,
    width: 131.38,
    height: 1.81
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.29,18.12c-1.66,0-3.02-1.35-3.02-3.02s1.35-3.02,3.02-3.02,3.02,1.35,3.02,3.02-1.35,3.02-3.02,3.02ZM121.29,13.89c-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2,1.2-.54,1.2-1.2-.54-1.2-1.2-1.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.2,18.12c-1.66,0-3.02-1.35-3.02-3.02s1.35-3.02,3.02-3.02,3.02,1.35,3.02,3.02-1.35,3.02-3.02,3.02ZM129.2,13.89c-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2,1.2-.54,1.2-1.2-.54-1.2-1.2-1.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.38,18.12c-1.66,0-3.02-1.35-3.02-3.02s1.35-3.02,3.02-3.02,3.02,1.35,3.02,3.02-1.35,3.02-3.02,3.02ZM113.38,13.89c-.66,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2,1.2-.54,1.2-1.2-.54-1.2-1.2-1.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.11,81.41h-40.08c-.55,0-.99-.45-.99-.99V29.56c0-.55.45-.99.99-.99h40.08c.55,0,.99.45.99.99v50.86c0,.55-.45.99-.99.99ZM89.86,79.59h38.43V30.38h-38.43v49.21Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 108.16,
    y: 22.49,
    width: 1.81,
    height: 64.99,
    transform: "translate(-10.62 79.36) rotate(-38.26)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.39,
    y: 28.56,
    width: 51.27,
    height: 1.81
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.39,
    y: 37.43,
    width: 51.27,
    height: 1.81
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.39,
    y: 46.29,
    width: 51.27,
    height: 1.81
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.39,
    y: 55.16,
    width: 51.27,
    height: 1.81
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.39,
    y: 64.02,
    width: 51.27,
    height: 1.81
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.39,
    y: 72.88,
    width: 24.22,
    height: 1.81
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 76.58,
    y: 54.08,
    width: 64.99,
    height: 1.81,
    transform: "translate(-1.63 106.61) rotate(-51.75)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.1a2cb69b73fcf8076ca8673d1d5de55d.svg";
export { ForwardRef as ReactComponent };